import type { CSSProperties } from 'react';

// Hubert's brand purple (#7543FF, darker #5F38CC on hover) instead of Radix's stock violet, and a
// pointer cursor (Radix buttons default to the arrow).
export const HUBERT_VIOLET = {
  '--accent-9': 'var(--violet, #7543ff)',
  '--accent-10': '#5f38cc',
  '--accent-contrast': '#fff',
  '--accent-track': 'var(--violet, #7543ff)',
  '--focus-8': 'var(--violet, #7543ff)',
  '--cursor-button': 'pointer',
} as CSSProperties;
